module.exports = __webpack_public_path__ + "media/Chapter3VoiceOver.20ac844e.mp3";